import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard/Dashboard.vue";
import Contacts from "../views/Contacts.vue";
import Calendar from "../views/Calendar.vue";
import Library from "../views/Library.vue";
import Contact from "../views/Contact.vue";
import Event from "../views/Event.vue";
import CreateEvent from "../views/Admin/CreateEvent/CreateEvent.vue";
import Config from "../views/Admin/Config/Config.vue";
import Header from "../Components/Header.vue";
import Navigation from "../Components/Navigation/Navigation.vue";
import Messaging from "../Components/Messaging/Messaging.vue";

// let dbUser;
// let setUser = async function () {
//   let user = await Auth.currentAuthenticatedUser();
//   if (user) {
//     let userId = user.username;
//     let tenantId = user.attributes["custom:tenantId"]
//       ? user.attributes["custom:tenantId"]
//       : userId;
//     return await axios
//       .get(
//         `https://9q6nkwso78.execute-api.us-east-1.amazonaws.com/Beta/admin/${tenantId}/users/${userId}`
//       )
//       .then((res) => {
//         // dbUser = res.data.Item;
//         return res.data.Item;
//       })
//       .catch((e) => {
//         console.log(e);
//       });
//   }
// };

const routes = [
  {
    path: "/dashboard",
    name: "dashboard",
    alias: "/",
    components: {
      main: Dashboard,
      header: Header,
      navigation: Navigation,
      chat: Messaging,
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/contacts",
    name: "contacts",
    components: {
      main: Contacts,
      header: Header,
      navigation: Navigation,
      chat: Messaging,
    },
    meta: {
      requiresAuth: true,
      requiresAdminAuth: true,
    },
  },
  {
    path: "/contact/:role/:userId",
    name: "contact",
    components: {
      main: Contact,
      header: Header,
      navigation: Navigation,
      chat: Messaging,
    },
    meta: { requiresAdminAuth: true, requiresAuth: true },

    props: true,
  },

  {
    path: "/calendar",
    name: "calendar",
    components: {
      main: Calendar,
      header: Header,
      navigation: Navigation,
      chat: Messaging,
    },
    meta: {
      requiresAuth: true,
      requiresAdminAuth: true,
    },
  },
  {
    path: "/config",
    alias: "/config/:category",
    name: "config",
    components: {
      main: Config,
      header: Header,
      navigation: Navigation,
      chat: Messaging,
    },
    meta: {
      requiresAuth: true,
      requiresAdminAuth: true,
    },
  },
  {
    path: "/event/:tenantId/:eventId",
    name: "event",
    components: {
      main: Event,
      header: Header,
      navigation: Navigation,
      chat: Messaging,
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/library",
    name: "library",
    components: {
      main: Library,
      header: Header,
      navigation: Navigation,
      chat: Messaging,
    },
    meta: {
      requiresAuth: true,
      requiresAdminAuth: true,
    },
  },
  {
    path: "/create-event",
    name: "create-event",
    components: {
      main: CreateEvent,
      header: Header,
      navigation: Navigation,
      chat: Messaging,
    },
    meta: {
      requiresAuth: true,
      requiresAdminAuth: true,
    },
  },
];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active-link",
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
      };
    }
  },
});

// router.beforeEach(async (to, from, next) => {
//   if (!dbUser) {
//     dbUser = await setUser();
//   }
//   console.log(to);
//   console.log(from);
//   if (to.matched.some((record) => record.meta.requiresAdminAuth)) {
//     if (user.attributes["custom:role"].includes("admin")) {
//       if (new Date(dbUser.subscriptionExpirationDate) < new Date()) {
//         next("/updatesubscription");
//       } else {
//         next();
//       }
//     } else {
//       next();
//     }
//   } else {
//     next();
//   }
// });

export default router;
